import React from 'react';
import { ButtonStyle, IconStyle, LinkButtonStyle } from './styles';

// Default style is primary color with meduim size

export const Button = ({
  secondary,
  gray,
  large,
  small,
  xSmall,
  rounded,
  wide,
  removeMargin,
  onClick,
  title,
  icon,
  children,
  ...props
}) => {
  return (
    <ButtonStyle
      secondary={secondary}
      gray={gray}
      large={large}
      small={small}
      xSmall={xSmall}
      rounded={rounded}
      wide={wide}
      removeMargin={removeMargin}
      title={title}
      onClick={onClick}
      {...props}
    >
      {icon && <IconStyle icon={icon} removeMargin={children === undefined} />}
      {children}
    </ButtonStyle>
  );
};

export const LinkButton = ({ href, icon, children, ...props }) => {
  return (
    <LinkButtonStyle href={href}>
      <Button removeMargin {...props}>
        {icon && <IconStyle icon={icon} removeMargin={children === undefined} />}
        {children}
      </Button>
    </LinkButtonStyle>
  );
};

export const ButtonsSystemDesign = () => {
  return (
    <>
      <div>
        <Button rounded large>
          Start to code
        </Button>
        <Button rounded>Start to code</Button>
        <Button rounded small>
          Start to code
        </Button>
        <Button rounded xSmall>
          Start to code
        </Button>
      </div>
      <div>
        <Button large>Start to code</Button>
        <Button>Start to code</Button>
        <Button small>Start to code</Button>
        <Button xSmall>Start to code</Button>
      </div>
      <div>
        <Button secondary large>
          Start to code
        </Button>
        <Button secondary>Start to code</Button>
        <Button secondary small>
          Start to code
        </Button>
        <Button secondary xSmall>
          Start to code
        </Button>
      </div>
      <div>
        <Button gray large>
          Start to code
        </Button>
        <Button gray>Start to code</Button>
        <Button gray small>
          Start to code
        </Button>
        <Button gray xSmall>
          Start to code
        </Button>
      </div>
      <div>
        <Button icon="fa-solid fa-play" rounded large>
          Start to code
        </Button>
        <Button icon="fa-solid fa-play" rounded>
          Start to code
        </Button>
        <Button icon="fa-solid fa-play" rounded small>
          Start to code
        </Button>
        <Button icon="fa-solid fa-play" rounded xSmall>
          Start to code
        </Button>
      </div>
      <div>
        <Button icon="fa-solid fa-play" large>
          Start to code
        </Button>
        <Button icon="fa-solid fa-play">Start to code</Button>
        <Button icon="fa-solid fa-play" small>
          Start to code
        </Button>
        <Button icon="fa-solid fa-play" xSmall>
          Start to code
        </Button>
      </div>
      <div>
        <Button icon="fa-solid fa-stop" rounded large />
        <Button icon="fa-solid fa-stop" rounded />
        <Button icon="fa-solid fa-stop" rounded small />
        <Button icon="fa-solid fa-stop" rounded xSmall />
      </div>
      <div>
        <Button icon="fa-solid fa-stop" large />
        <Button icon="fa-solid fa-stop" />
        <Button icon="fa-solid fa-stop" small />
        <Button icon="fa-solid fa-stop" xSmall />
      </div>
    </>
  );
};
